import React from 'react';
import { Link } from 'react-router-dom';
import './SiteFooter.css';

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer__content">
        <p className="site-footer__copyright">&copy; {new Date().getFullYear()} Sober Living Support. All rights reserved.</p>
        <nav className="site-footer__links" aria-label="Footer navigation">
          <Link to="/about">About</Link><Link to="/privacy">Privacy</Link><Link to="/terms">Terms</Link><Link to="/contact">Contact</Link>
        </nav>
        <div className="site-footer__powered" aria-label="Powered by Task Driven Solutions">
          <span className="site-footer__label">Powered by</span>
          <span className="site-footer__mark" aria-hidden="true">TDS</span>
          <span className="site-footer__partner">
            <strong>Task Driven Solutions</strong>
            <small>Building technology. Driving results.</small>
          </span>
        </div>
      </div>
    </footer>
  );
}
